// @flow
import { connect } from 'react-redux';
import type { State } from '../../../types';
import userActions from '../../../actions/userActions';
import { isLoadingSelector } from '../../../selectors/userSelectors';
import Login from '../Login';
import type { Props } from '../Login';

const mapStateToProps = (state: State) => {
    return {
        isLoading: isLoadingSelector(state)
    };
};

const mapDispatchToProps = {
    loggingIn: userActions.loggingIn
};

export default connect<Props, *, _, _, _, _>(mapStateToProps, mapDispatchToProps)(Login);